const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

export const createLocalAuthUser = () => ({
  uid: 'local-dev-user',
  email: 'local-dev@swingtraderedge.local',
  displayName: 'Local Dev User',
});

export const isLocalAuthFallbackEnabled = ({ hasFirebaseConfig, hostname }) => {
  return (
    process.env.NODE_ENV !== 'production' &&
    !hasFirebaseConfig &&
    LOCAL_HOSTNAMES.has(hostname)
  );
};
